export default ({ ...props }) => {
    const data = [{
        text: "Home",
        url: "/"
    },
    ...props.nextMenu]
    const dataLen = data.length - 1
    
    return (
        <div>
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-transparent mt-2 mb-0">
                        {
                            data.map((item, key) => (
                                <li key={key} className="breadcrumb-item"><a className={(key==dataLen ? "text-primary":"text-dark")+(" font-weight-bold")} href={item.url}>{item.text}</a></li>
                            ))
                        }
                    </ol>
                </nav>
            </div>
            <style jsx>
                {`
                    @import './styles/jmto-custom';
                `}
            </style>
        </div>
    )
}